export default "__VITE_ASSET__c88510ee__"